import {
  addressSuggestDetails as addressSuggestDetailsUrl,
  addressSuggest as addressSuggestUrl,
  getCybwellToken as getCybwellTokenUrl,
} from '@atpoint/atpjs/api/cybwell'
import { cybwellAddressDetail, cybwellAddressSuggest, cybwellToken } from '@forms/config/requests'

export const getCybwellToken = getCybwellTokenUrl(cybwellToken)

export const addressSuggest = addressSuggestUrl(cybwellAddressSuggest, getCybwellToken)

export const addressSuggestDetails = addressSuggestDetailsUrl(cybwellAddressDetail, getCybwellToken)
